export function getEnumKeys<T>(enumObject: T): (keyof T)[] {
	return Object.keys(enumObject).filter(k => !Number.isInteger(k as any)) as (keyof T)[];
}

export function getEnumValues<T>(enumObject: T): number[] {
	return Object.values(enumObject).filter(v => Number.isInteger(v)) as number[];
}
